<template>
  <div class="xy-content-module">
    <div class="timeTitle">{{ todayText }}</div>
    <div class="assessView" v-if="Teacherlist.length">
      <div class="xy-left-list">
        <userCard
          @click.native="getDetailedData(item)"
          class="cardout"
          :current="current"
          :card="item"
          v-for="item in Teacherlist"
          :key="item.id"
        />
      </div>
      <div class="xy-right-show" v-if="current">
        <div class="quota" v-if="totalQuota">
          <div class="quotaTitle">指标分析</div>
          <div class="oneCanvas">
            <div ref="oneTU" class="replaceView"></div>
          </div>
        </div>
        <div class="quotaDeteil" v-for="quota in quotaList" :key="quota.index">
          <div class="circle l-cir"></div>
          <div class="circle r-cir"></div>
          <div class="quotaDeteilTitle">{{ quota.name }}</div>
          <div ref="quota" class="replaceView"></div>
        </div>
      </div>
    </div>
    <div class="assessView null-data" v-if="!Teacherlist.length && isSend">
      <img src="@/assets/common/moblie-no-data.png" />
      <div>暂无评价结果</div>
    </div>
  </div>
</template>
<script>
  import userCard from './userCard'
  import { Toast } from 'vant'
  var option = {
    type: 'pie',
    label: {
      color: '#979797',
      formatter(e) {
        return `${e.name}: ${e.percent} %`
      }
    },
    // itemStyle: {
    //   normal: {
    //     borderWidth: 1.5,
    //     borderColor: '#eee'
    //   }
    // },
    color: ['#1890FF', '#13C2C2', '#2FC25B', '#FACC14', '#F04864', '#8543E0']
  }
  export default {
    name: '',
    data() {
      return {
        current: null,
        date: this.xy.moment().format('YYYY-MM-DD'),
        isSend: false,
        scode: '',
        totalQuota: 1,
        quotaList: [],
        Teacherlist: []
      }
    },
    computed: {
      todayText() {
        return (
          this.xy.moment().format('YYYY-MM-DD') +
          ' ' +
          this.xy.getChinesesWeekForNumSmall(new Date().getDay() - 1)
        )
      }
    },
    components: {
      userCard
    },
    mounted() {
      this.getListData()
    },
    watch: {
      current(val) {
        this.getRingData(val)
        this.getpieData(val)
      }
    },
    methods: {
      async getListData() {
        this.loading()
        // 左侧列表数据
        const { data } = await this.xyapi.get(
          `${this.$store.state.apiPath}/api/GradeAndClassStatistics/GetStudentClassScoreInfo`
        )
        this.xy.unloading()
        this.Teacherlist = data
        this.isSend = true
      },
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      getDetailedData(item) {
        if (
          (this.current && this.current.ClassTableGenerateBaseID) === item.ClassTableGenerateBaseID
        ) {
          return
        }
        this.current = item
      },
      async getpieData(data) {
        // 具体指标分析
        let { data: list } = await this.xyapi.post(
          `${this.$store.state.apiPath}/api/MyEvaluationStatistics/GetTwoStudentEvaluationStatistics`,
          {
            SchoolDistrictID: data.SchoolDistrictID,
            StudentGradeForStudentYearID: data.StudentGradeForStudentYearID,
            DisciplineID: data.DisciplineID,
            // 条件筛选
            AcademicSessionID: data.selectSessionId,
            StarTime: this.date,
            EndTime: this.date,
            AcademicYearID: data.AcademicYearID,
            CoursePlan: {
              CoursePlanAID: data.CoursePlanAID,
              CoursePlanAIDType: data.CoursePlanAIDType
            }
          }
        )
        list = list.map(item => {
          return {
            name: item.ObjectName,
            data: item.Datas.map(i => ({
              name: i.ObjectName,
              value: i.ObjectScore
            }))
          }
        })
        this.quotaList = list
        this.$nextTick(() => {
          this.creatDetailedQuotaView(list)
        })
      },
      creatDetailedQuotaView() {
        for (var i = this.quotaList.length - 1; i > -1; i--) {
          let initOption =
            this.quotaList[i].data.length < 2
              ? option
              : {
                  ...option,
                  itemStyle: {
                    normal: {
                      borderWidth: 1.5,
                      borderColor: '#eee'
                    }
                  }
                }
          let list = this.$refs.quota
          this.echarts.init(list[i]).setOption(
            {
              series: {
                ...initOption,
                data: this.quotaList[i].data
              }
            },
            true
          )
        }
      },
      async getRingData(data) {
        //  指标分析
        let { data: list } = await this.xyapi.post(
          `${this.$store.state.apiPath}/api/MyEvaluationStatistics/GetOneStudentEvaluationStatisticsPie`,
          {
            SchoolDistrictID: data.SchoolDistrictID,
            StudentGradeForStudentYearID: data.StudentGradeForStudentYearID,
            DisciplineID: data.DisciplineID,
            // 条件筛选
            AcademicSessionID: data.AcademicSessionID,
            CoursePlan: {
              CoursePlanAID: data.CoursePlanAID,
              CoursePlanAIDType: data.CoursePlanAIDType
            },
            AcademicYearID: data.AcademicYearID,
            StarTime: this.date,
            EndTime: this.date
          }
        )
        this.totalQuota = null
        if (!list.length) return
        this.totalQuota = list
        this.$nextTick(() => {
          this.creatTotalVIew(list)
        })
      },
      creatTotalVIew(list) {
        let temp = this
        let el = this.$refs.oneTU
        let initOption =
          list.length < 2
            ? option
            : {
                ...option,
                itemStyle: {
                  normal: {
                    borderWidth: 1.5,
                    borderColor: '#eee'
                  }
                }
              }
        this.echarts.init(el).setOption(
          {
            graphic: [
              {
                type: 'text', // 通过不同top值可以设置上下显示
                left: 'center',
                top: '40%',
                style: {
                  text: '总得分',
                  textAlign: 'center',
                  fill: '#27262680', // 文字的颜色
                  fontSize: 13
                }
              },
              {
                type: 'text', // 通过不同top值可以设置上下显示
                left: 'center',
                top: '50%',
                style: {
                  text: temp.current ? temp.current.Score : '',
                  textAlign: 'center',
                  fill: '#000', // 文字的颜色
                  fontSize: 22
                }
              }
            ],
            series: {
              radius: ['40%', '70%'],
              ...initOption,
              data: list.map(item => ({
                name: item.ObjectName,
                value: item.ObjectScore
              }))
            }
          },
          true
        )
      }
    }
  }
</script>
<style lang="less" scoped>
  .timeTitle {
    padding-left: 21px;
    height: 33px;
    width: 100%;
    line-height: 33px;
    // prettier-ignore
    font-size: 15Px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
  .assessView {
    width: 100%;
    height: 670px;
  }
  .cardout {
    margin-bottom: 10px;
  }
  .xy-left-list,
  .xy-right-show {
    // border: 1px red solid;
    float: left;
    width: 325px;
    height: 100%;
    overflow: auto;
  }
  .xy-right-show {
    width: 680px;

    background: #fff;
    position: relative;
    overflow-x: hidden;
    .quota {
      height: 340px;
      border-top: 1px white solid;
      .quotaTitle {
        margin: 20px;
        // prettier-ignore
        font-size: 18Px;
        font-weight: 500;
      }
      .oneCanvas {
        position: relative;
        width: 100%;
        height: 250px;
        margin: 0 auto;
        .replaceView {
          width: 100%;
          height: 100%;
        }
      }
    }
    .circle {
      position: absolute;
      width: 16px;
      height: 16px;
      background: #f5f5f5;
      border-radius: 50%;
      top: -8px;
    }
    .l-cir {
      left: -8px;
    }
    .r-cir {
      right: -8px;
    }
    .quotaDeteil {
      position: relative;
      border-top: 1px #d5d5d5 dashed;
      height: 331px;
      .quotaDeteilTitle {
        margin: 20px;
        // prettier-ignore
        font-size: 16Px;
        font-weight: 400;
        color: rgba(26, 26, 26, 0.86);
      }
      .replaceView {
        width: 100%;
        height: 250px;
        margin: 0 auto;
      }
    }
  }
  .null-data {
    margin-top: 100px;
    text-align: center;
    div {
      // prettier-ignore
      font-size:18Px;
    }
  }
</style>
